var map = {
	"./Group 7.png": 328,
	"./logo-footer.png": 861,
	"./logo.png": 427,
	"./web1.png": 339,
	"./web1_2.png": 892,
	"./web1_wide.png": 898,
	"./web2.png": 460,
	"./web2_2.png": 413,
	"./web2_wide.png": 89,
	"./web3.png": 63,
	"./web3_2.png": 409,
	"./web3_wide.png": 298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;